import script from "./Product.vue?vue&type=script&setup=true&lang=js"
export * from "./Product.vue?vue&type=script&setup=true&lang=js"

import "./Product.vue?vue&type=style&index=0&id=4009e1f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4009e1f0"]])

export default __exports__